export const REFERENTIAL_AUTOVISTA_FR = '1'
export const REFERENTIAL_JATO_ES = '2'
export const REFERENTIAL_JATO_IT = '3'
export const REFERENTIAL_DAT_DE = '4'
export const REFERENTIAL_SANGUINETTI_IT = '5'
export const REFERENTIAL_AUTOBIZ = '6'
export const REFERENTIAL_AUTOVISTA_ES = '7'
export const REFERENTIAL_AUTOVISTA_IT = '8'
export const REFERENTIAL_AUTOVISTA_BE = '9'
export const REFERENTIAL_BEE2LINK_FR_MOTORCYCLE = '10'
export const REFERENTIAL_AUTOVISTA_PT = '11'

export const isReferentialAutovista = referential =>
  [
    REFERENTIAL_AUTOVISTA_FR,
    REFERENTIAL_AUTOVISTA_ES,
    REFERENTIAL_AUTOVISTA_IT,
    REFERENTIAL_AUTOVISTA_BE,
    REFERENTIAL_AUTOVISTA_PT
  ].includes(referential)
